import {Enum} from 'enumify';

export default class InputValidationType extends Enum {}

InputValidationType.initEnum({
  NULL: {
    validationName: null,
  },
  SUCCESS: {
    validationName: 'success',
  },
  WARNING: {
    validationName: 'warning',
  },
  ERROR: {
    validationName: 'error',
  },
});



// WEBPACK FOOTER //
// ./src/constants/InputValidationType.js